import {createApp} from 'vue'
import App from './App.vue'

import router from './router'
import {store} from './store'
import ElementPlus from "element-plus";
import tr from "element-plus/es/locale/lang/tr";
import i18n from "@/core/plugins/vue-i18n";
import Validation from "@/core/helpers/validation";
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice';
import Aura from '@primevue/themes/aura'
import Tooltip from 'primevue/tooltip';
import Alert from "@/components/custom/Alert.vue";
import EmptyState from "@/components/custom/EmptyState.vue";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import {initApexCharts} from "@/core/plugins/apexcharts";
import {initInlineSvg} from "@/core/plugins/inline-svg";
import {initVeeValidate} from "@/core/plugins/vee-validate";
import {initGlobal} from "@/core/plugins/global";

import { definePreset } from '@primevue/themes'

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import 'primeicons/primeicons.css'

const app = createApp(App);
const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50:  'oklch(97% 0.014 254.604)',
            100: 'oklch(93.2% 0.032 255.585)',
            200: 'oklch(82% 0.11 258.2)',
            300: 'oklch(74% 0.16 259.1)',
            400: 'oklch(68% 0.195 259.6)',
            500: 'oklch(62.3% 0.214 259.815)',
            600: 'oklch(54.6% 0.245 262.881)',
            700: 'oklch(48.8% 0.243 264.376)',
            800: 'oklch(42.4% 0.199 265.638)',
            900: 'oklch(28.2% 0.091 267.935)',
            950: 'oklch(22% 0.06 268.5)'
        },
    }
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.dark',
        }
    }
})
app.use(ConfirmationService);

app.directive('tooltip', Tooltip);

app.component('Alert', Alert);
app.component('EmptyState', EmptyState);
app.component('MDrawer', require('@/components/manager/MDrawer.vue').default);

app.use(router);

app.use(ElementPlus, {
    locale: tr
});

app.use(i18n);

store._vm = app.config.globalProperties;
app.use(store);


ApiService.init(app);
Validation.init(app);

initApexCharts(app);
initInlineSvg(app);
initGlobal(app);
initVeeValidate();

app.mount("#app");
